import { apiClient, getHash, getImage, __sortBy } from '../../utils';
import { handleError } from '../';
import { composeTile } from './composeTile';

export const editTile = async ({
  siteId,
  tileCollectionId,
  tileItems = [],
  sliderItems = null,
  status,
  title,
}) => {
  try {
    await (tileItems || []).reduce(
      (acc, { file, id, caption, link, modified }, ci) =>
        acc.then(
          (_) =>
            new Promise((resolve, reject) =>
              !modified
                ? resolve()
                : composeTile({
                    slideId: id,
                    sliderId: tileCollectionId,
                    siteId,
                    file,
                    caption,
                    url: link,
                  })
                    .then(({ result }) => {
                      const _tileItems = result?.slider?.items || result?.items;
                      const { _id, url, cover } = _tileItems[ci];
                      if (_id) tileItems[ci].id = _id;
                      if (cover?.hash)
                        tileItems[ci].file = getImage(cover.hash, 'original');
                      if (cover?.url) tileItems[ci].url = cover.url;
                      if (cover?.caption) tileItems[ci].caption = cover.caption;
                      resolve(_tileItems[ci]);
                    })
                    .catch((err) => reject(err))
            )
        ),
      Promise.resolve()
    );
    const newTileItems = __sortBy(tileItems, 'order').map(
      ({ id, file, caption, link }) => ({
        cover: { hash: getHash(file), type: 0, caption, mimeType: 'image/png' },
        url: link,
      })
    );
    const payload = {
      data: {
        site: siteId,
        slider: tileCollectionId,
        ...(title ? { title } : {}),
        ...(status !== undefined ? { status } : {}),
        ...(newTileItems.length ? { items: newTileItems } : {}),
        ...(Array.isArray(sliderItems) ? { items: sliderItems } : {}),
      },
    };
    const { result } = await apiClient.post('/merchant/slider/edit', payload);
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
